import React from 'react';
import PropTypes from 'prop-types';

const ExternalLinkWrapper = ({ path, className, content, target, rel, onClick }) => (
    <a className={className} href={path} target={target} rel={rel} onClick={onClick}>
        {content}
    </a>
);

ExternalLinkWrapper.defaultProps = {
    path: {},
    className: '',
    content: null,
    target: '_blank',
    rel: 'noreferrer noopener',
    onClick: () => {},
};

ExternalLinkWrapper.propTypes = {
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    className: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.object, PropTypes.node, PropTypes.string]),
    target: PropTypes.string,
    rel: PropTypes.string,
    onClick: PropTypes.func,
};

export default ExternalLinkWrapper;
